// extracted by mini-css-extract-plugin
export default {"watermark-center":"Watermark_watermark-center__sv8Nx"};